/**
 * Duração padrão dos toasts, por severidade.
 *
 * Antes cada tela escolhia a sua: havia 11 valores diferentes em uso (de 1 ms a 15 s)
 * para as mesmas situações — um erro sumia em 2 s numa tela e ficava 15 s em outra.
 * A escala cresce com a importância da mensagem e com o tamanho típico do texto:
 * `detail` de erro costuma ser uma frase inteira vinda da API, e 3 s não dá tempo de ler.
 *
 * Aplicada centralmente em `main.js`, ao envolver o `add` do ToastService. Passar
 * `life` explicitamente continua funcionando e vence o padrão — é a saída para o caso
 * raro que precise de outra duração.
 */
export const DURACAO_TOAST = Object.freeze({
    success: 3000,
    info: 4000,
    warn: 5000,
    error: 10000,
});

/** Usada quando a mensagem não informa `severity`. */
export const DURACAO_TOAST_PADRAO = 4000;

/**
 * @param {string|null|undefined} severity
 * @returns {number} duração em milissegundos
 */
export function duracaoToast(severity) {
    /*
     * Checagem de propriedade própria, e não `DURACAO_TOAST[severity] ?? padrão`:
     * um severity como 'constructor' ou 'toString' acharia o membro do protótipo,
     * o `??` não agiria e `life` viraria uma função — o PrimeVue trataria como
     * timeout inválido e o toast piscaria na tela.
     */
    return Object.prototype.hasOwnProperty.call(DURACAO_TOAST, severity) ? DURACAO_TOAST[severity] : DURACAO_TOAST_PADRAO;
}

/**
 * Completa a mensagem com a duração padrão da sua severidade, preservando um `life`
 * informado pelo chamador.
 *
 * @param {Record<string, unknown>|null|undefined} mensagem
 * @returns {Record<string, unknown>}
 */
export function comDuracaoPadrao(mensagem) {
    const base = mensagem ?? {};
    return { ...base, life: base.life ?? duracaoToast(base.severity) };
}
